import React, { useState } from "react";
import "./AgeAnalysis.css";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn";
import IconButton from "@mui/material/IconButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Container from "@material-ui/core/Container";
import BoxWrapper from "../../../../../components/ui/boxWrapper";

export default function AgeAnalysisLastMonth({ LastMonth, LastMonthTotal }) {
  //..............Indian Rupees.................
  const indianRupeesFormat = (value) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumSignificantDigits: 10,
    }).format(value);

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = useState(false);

    return (
      <React.Fragment>
        <tr>
          <td>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? (
                <DoNotDisturbOnIcon style={{ color: "black" }} />
              ) : (
                <AddCircleIcon style={{ color: "black" }} />
              )}
            </IconButton>
          </td>
          <td>{row.Partner.Partner_Name}</td>
          <td>
            {indianRupeesFormat(row.Partner.Sum_of_Receivable_till_Last_Month)}
          </td>
        </tr>

        <tr>
          {" "}
          <td colSpan={"3"}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Client Details/{row.Partner.Partner_Name}
                </Typography>
                <Table size="small" aria-label="purchases">
                  <thead>
                    <TableRow>
                      <th>Name Of Client</th>
                      <th>Amt Received Till Last Month</th>
                    </TableRow>
                  </thead>
                  <tbody>
                    {row.clients.map((value, index) => (
                      <TableRow key={index}>
                        <th>{value.Name_of_Clients}</th>
                        <td>
                          {indianRupeesFormat(
                            value.Sum_of_Receivable_till_Last_Month
                          )}
                        </td>
                      </TableRow>
                    ))}
                  </tbody>
                </Table>
              </Box>
            </Collapse>
          </td>
        </tr>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div style={{ marginTop: "30px" }}>
        <BoxWrapper boxTitle="Age analysis last month">
          <div className="titleStyle" style={{ background: "#ddd" }}>
            <div style={{ padding: "5px", paddingLeft: "20px" }}>
              {LastMonthTotal.Total_Sum_of_Receivable_till_Last_Month ? (
                <div>
                  Amount Received Till Last Month:{" "}
                  {indianRupeesFormat(
                    LastMonthTotal.Total_Sum_of_Receivable_till_Last_Month
                  )}{" "}
                </div>
              ) : (
                <div>Amount Received Till Last Month: ₹0</div>
              )}
            </div>
          </div>

          <div className="table">
            <div className="tableResponisve">
              <table className="tablecss">
                <thead>
                  <tr>
                    <th>Client Details</th>
                    <th>Partner Name</th>
                    <th>Amt Received Till Last Month</th>
                  </tr>
                </thead>
                <tbody>
                  {LastMonth.map((value) => (
                    <Row row={value} />
                  ))}
                  {LastMonth.length === 0 && (
                    <tr>
                      <td
                        colSpan={"7"}
                        style={{ color: "red", textAlign: "center" }}
                      >
                        No Data Found!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </BoxWrapper>
      </div>
    </React.Fragment>
  );
}
